import { getTimezoneOffset } from 'date-fns-tz';

export const isLocalTimeZoneSameAsCopenhagenTimeZone = () => {
  const now = new Date();

  const danishOffset = getCopenhagenTimeOffsetInMins(now);
  const localOffset = getLocalTimeOffsetInMin(now);

  return localOffset === danishOffset;
};

/**
 * @param now The current date time
 * @returns Number of minutes from UTC, positive means ahead
 */
export const getCopenhagenTimeOffsetInMins = (now: Date): number =>
  getTimezoneOffset('Europe/Copenhagen', now) / 1000 / 60;

/**
 * @param now The current date time
 * @returns Number of minutes from UTC, positive means ahead
 */
export const getLocalTimeOffsetInMin = (now: Date): number => now.getTimezoneOffset() * -1;
